<script setup>
  import { ref, computed, onMounted, onUnmounted } from "vue";

  const props = defineProps({});

  const response = ref({
    items: [],
  });

  const visibleItems = computed(() => {
    if (!response.value || !response.value.items) return [];
    return response.value.items;
    /*.filter((item) => {
      return !item.name.toLowerCase().includes("taxa ecovalor");
    });*/
  });
  const formatPrice = (price) => {
    if (price === undefined || price === null) return "0";
    // Arredonda para no máximo 3 casas decimais e remove zeros desnecessários no final
    return Number(price)
      .toFixed(3)
      .replace(/\.?0+$/, "");
  };
  const onDeleteItem = (idProduct) => {
    window.cart.update(
      {
        items: [
          {
            id: idProduct,
            quantity: 0,
          },
        ],
      },
      (newResponse) => {
        response.value = newResponse;
        window.dispatchEvent(new CustomEvent("cart-updated"));
      },
    );
  };

  let intervalId;

  const fetchCartData = () => {
    window.cart.get((newResponse) => {
      response.value = newResponse;
    });
  };

  onMounted(() => {
    fetchCartData();
    window.addEventListener("cart-updated", fetchCartData);

    intervalId = setInterval(() => {
      if (window.cartUpdated) {
        window.cartUpdated = false;
        fetchCartData();
      }
    }, 500);
  });

  onUnmounted(() => {
    clearInterval(intervalId);
    window.removeEventListener("cart-updated", fetchCartData);
  });
</script>

<template>
  <div class="content-cart">
    <div class="container-geral">
      <div v-if="visibleItems.length >= 1">
        <div class="content-product">
          <div
            class="shopping-painel-cart-item"
            v-for="item in visibleItems"
            :key="item.id">
            <div class="container-list-produts">
              <div class="container-cart-items">
                <div class="content-image">
                  <img
                    alt=""
                    :src="item.image ? item.image.fullUrl : ''"
                    :title="item.image ? item.image.title : ''" />
                </div>
                <div class="shopping-painel-cart-item-title">
                  <p class="title">{{ item.name }}</p>
                  <div class="container-quantity">
                    <span>{{ item.quantity }} un.</span>
                    <span>{{ formatPrice(item.final_line_price) }} €</span>
                  </div>
                </div>
              </div>
              <button class="delete" @click="onDeleteItem(item.id)">x</button>
            </div>
          </div>
        </div>

        <div class="content-button">
          <div class="shopping-painel-options">
            <a class="btn btn-final" :href="`/account#cart`">
              Finalizar compra
            </a>
          </div>
        </div>
      </div>

      <div class="content-list-shop" v-if="visibleItems.length == 0">
        <p>Nenhum produto no carrinho.</p>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
